import { useViewContext } from "@folksam/ui/providers/ViewContext";
import { useEffect } from "react";

import { useGetSdlConfig } from "../../../components/hooks";
import { dataMappingForFilters, filterData } from "../../../services";
import { Box, Flex } from "../../cores";
import {
  useComparePreviusValuesWithCurrent,
  useUpdateRowPumpData,
} from "../../hooks";
import { IconScales } from "../../icons";
import { Button } from "../../molecules";
import { sortTable } from "../../molecules/Table/SortTable";
import {
  ContentDescriptionContainer,
  FilterCollection,
  TableWithPages,
} from "../../organisms";
import { useTableContext } from "../../providers";
import { IKeyStringAndValue, IOptions } from "../../types/Types";

export default function PumpView() {
  const data = useUpdateRowPumpData();
  const { listView } = useTableContext();
  const sdlConfig = useGetSdlConfig(listView).data as Array<IOptions>;
  //Data reduced by all filters
  //Filter key and values for filtering data
  const {
    filteredData,
    setFilteredData,
    filterOptions,
    setSortedField,
    arrowState,
    setArrowState,
    setCurrentPage,
    selected,
    selectedData,
    setSelectedData,
    isCompare,
    setIsCompare,
    setInputValue,
  } = useTableContext();

  const { isMobile } = useViewContext();

  const { filteredDataSnapshot } = useComparePreviusValuesWithCurrent(
    filteredData,
    filterOptions,
    setInputValue
  );

  const checkIfEffAnm = filteredData.some((el) => el.EffAnm === "1");
  const checkIfVarvtalsstyrd = filteredData.some((el) =>
    el.Modell.includes("Varvtalsstyrd")
  );

  useEffect(() => {
    sortTable(
      sdlConfig[0].key,
      filterData(isCompare ? selectedData : data, sdlConfig, filterOptions),
      setFilteredData,
      arrowState ? !!arrowState : !arrowState,
      setCurrentPage
    );
    setArrowState(
      !arrowState
        ? (prevArrowState) => !!prevArrowState
        : (prevArrowState) => !prevArrowState
    );
    setSortedField(sdlConfig[0].key);
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filterOptions, isCompare, selectedData]);

  const onClick = () => {
    const selectedDataFilter = data.filter((element: IKeyStringAndValue) => {
      return selected.includes(element);
    });
    setSelectedData(selectedDataFilter);

    setIsCompare(isCompare ? false : true);
  };

  return (
    <Box sx={{ maxWidth: "1240px", margin: "auto", paddingTop: 20 }}>
      <FilterCollection
        filteredCategories={
          dataMappingForFilters({ filteredData: filteredDataSnapshot })
            .categories
        }
        allCategories={dataMappingForFilters({ filteredData: data }).categories}
      />
      <Flex
        sx={{
          flexWrap: "wrap",
          marginY: 14,
          flexDirection: "column",
          width: isMobile ? "calc(100% - 32px)" : "fit-content",
          marginBottom: !isMobile ? "-49px" : null,
          "> button": {
            margin: "14px 16px",
          },
        }}
      >
        <Button
          text={isCompare ? "Avbryt jämför" : "Jämför markerade objekt"}
          iconLeft={IconScales}
          size="md"
          fullWidth={isMobile}
          disabled={!isCompare && selected.length < 2}
          onClick={onClick}
          variant={"secondary"}
        />
      </Flex>
      <ContentDescriptionContainer
        columns={sdlConfig}
        filterOptions={filterOptions}
      />
      <TableWithPages data={data} />
    </Box>
  );
}
